import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/views/home'

import { store } from '@/store/store.js';

import misCandidaturas from '@/components/views/mis-candidaturas';
import micv from '@/components/views/mi-cv';
import login from '@/components/views/login';
import oportunidadesInternacionales from '@/components/views/oportunidades-internacionales';
import ofertas from '@/components/views/ofertas';
import fichaoferta from '@/components/views/ficha-oferta';
import rgpd from '@/components/views/rgpd';
import politicaprivacidad from '@/components/views/politica-de-privacidad';
import avisolegal from '@/components/views/aviso-legal';
import logout from '@/components/views/logout';

import Error404 from '@/components/views/error-404'

Vue.use(Router)

import messages from '@/translations';

let es = messages.es.enlaces;

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: es.home,
			name: 'home',
			component: Home,
			meta: {
				requiresAuth: true,
				title : 'ESIC'
			}
		},
		{
			path: es.login,
			name: 'login',
			component: login,
			meta :{
				title : 'ESIC - Login'
			}
		},
		{
			path: es.miscandidaturas,
			name: 'mis-candidaturas',
			component: misCandidaturas,
			meta: {
				requiresAuth: true,
				title : 'ESIC - Mis candidaturas'
			}
		}, {
			path: es.micv,
			name: 'mi-cv',
			component: micv,
			meta: {
				requiresAuth: true,
				title : 'ESIC - Mi CV'
			}
		}, {
			path: es.rgpd,
			name: 'rgpd',
			component: rgpd,
			meta: {
				requiresAuth: true,
			}
		}, {
			path: es.oportunidadesinternacionales,
			name: 'oportunidadesInternacionales',
			component: oportunidadesInternacionales,
			meta: {
				requiresAuth: true,
				title : 'ESIC - Portales globales'
			}
		}, , {
			path: `${es.ofertas}/:page?`,
			name: 'ofertas',
			component: ofertas,
			meta: {
				requiresAuth: true,
				title : 'ESIC - Ofertas'
			}
		}, {
			path: `${es.oferta}/:id?`,
			name: 'ficha-oferta',
			component: fichaoferta,
			meta: {
				requiresAuth: true,
			}
		}, {
			path: es.logout,
			name: 'logout',
			component: logout,
		},{
			path: es.politicaprivacidad,
			name: 'politicaprivacidad',
			component: politicaprivacidad,
		},
		{
			path: es.avisolegal,
			name: 'avisolegal',
			component: avisolegal,
		},
		{ path: '*', redirect: '/' },
		{ path: '/', redirect: '/candidatos' },
		{ path: "/404", component: Error404 }
	],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	},
});

// import VueAnalytics from 'vue-analytics';

// Vue.use(VueAnalytics, {
// 	id: 'UA-117270-3',
// 	router,
// 	debug : {sendHitTask: location.hostname.includes('ajusa.es')}
// });

router.beforeEach((to, from, next) => {

	if(!!to.meta.title){	
		document.title = to.meta.title
		//document.head.querySelector("[name=description]").content = meta.description;
	}

	//COMPRUEBO SI TIENE QUE ACEPTAR LA RGPD Y LE LLEVO
	if ((store.getters.gethasRGPD) && (to.path != es.rgpd) && (store.getters.getLogged)) {
		next({ name: 'rgpd' });
		return
	}

	//COMPRUEBO INICIO DE SESIÓN Y SI ESTÁ LOGADO
	if (to.matched.some(route => route.meta.requiresAuth) && !store.getters.getLogged) {
		next({ name: 'login' })
		return
	}

	//COMPRUEBO SI TIENE SESIÓN INICIADA Y LE LLEVO A LA HOME
	if ((to.path.indexOf('/login') != -1) && store.getters.getLogged) {
		next({ name: 'home' })
		return
	}

	next()
});

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js